import _ from "lodash";
import ConfigUtils from "./ConfigUtils";
import { PERMITTED_ROLES } from "../constants/UserRoles";

class StatusUtils {
  static maskStatus = (item, type, role?: string) => {
    const val = _.isString(item) ? item : _.get(item,'status','');
    const statusArray = _.result(_.find(ConfigUtils.getStatuses(), { role: _.includes(PERMITTED_ROLES.STATUS, role) || type === "MEDIA_REQUEST" ? 'ops' : role }), 'statuses');
    return _.result(_.find(statusArray,{value: val}),'label');
  }
  static checkForWorkFlowStatus(status) {
    return /^(INITIATE_WORKFLOW|RESUME_WORKFLOW)$/.test(status) || (_.includes(status, "WF") && !/^(WF_DONE|WF_PARTIAL|WF_VIP)$/.test(status));
  }

  static isWorkflowError(status) {
    return status === "WF_ERROR";
  }
  
  static containsWorkFlowAndNonWorkFlowStatuses(jobs) {
    let theJobs = jobs;
    let containsWorkFlowAndNonWorkFlowStatuses = false;
    _.map(theJobs, (jobValue) => {
      if (!/^(COMPLETE|CANCELLED)$/.test(_.get(jobValue, "status"))) {
        jobValue.checkForAction = true;
      }
      if (StatusUtils.checkForWorkFlowStatus(_.get(jobValue, "status")) && !StatusUtils.isWorkflowError(_.get(jobValue, "status")) && _.get(jobValue, "checkForAction", false)) {
        containsWorkFlowAndNonWorkFlowStatuses = true;
      }
    });
    return containsWorkFlowAndNonWorkFlowStatuses;
  }
}

export default StatusUtils;
